import React, { useRef, useState } from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import {
  validaSoloNumero
} from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes';
import moment from 'moment';
import CatalogoAlmacen from '../../catalogos/catalogoAlmacen';
import CatalogoCliente from '../../catalogos/catalogoCliente';

export const ImprimirCuentasxCobrarEstadosCuentas = (props) => {

  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  const fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));


  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtTodasFechas = useRef();
  const txtPorFechas = useRef();
  const txtTodosDispo = useRef();
  const txtCanceladas = useRef();
  const txtDeudas = useRef();
  const txtTodosCliente = useRef();
  const txtVipCliente = useRef();
  const txtRegulares = useRef();
  const txtPorCliente = useRef();
  const txtIdProducto = useRef();
  const txtRifrespon = useRef();
  const txtNomrespon = useRef();
  const txtDesde = useRef();
  const txtHasta = useRef();
  const txtCbmrif = useRef();

  const [inputalmacen, setInputalmacen] = useState(0);
  const [inputproducto, setInputproducto] = useState(0);
  const [tiporif, setTipofic] = useState(null);
  const [tituloc, setTituloc] = useState('');
  const [mostrar1, setMostrar1] = useState(null);
  const [parafecha, setParafecha] = useState('');
  const [desde, setDesde] = useState('');
  const [hasta, setHasta] = useState('');
  const [disponiblec, setDisponiblec] = useState('');
  const [paracliente, setParacliente] = useState('');
  const [idclient, setIdclient] = useState('');
  const [report, setReport] = useState('');
  const [activate, setActivate] = useState(false);
  const [habilitado, setHabilitado] = useState(true);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [tituid, setTituid] = useState('');
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    salir: false
  });



  const blanquear = () => {
    setActivate(false);
    setInputalmacen(0);
    setParafecha('');
    setDisponiblec('');
    setParacliente('');
    setInputproducto(0);
    setReport('');
    setIdclient('');
    setTituid('');
  }

  const cancelar = () => {
    blanquear();
    props.onHideCancela();

  };

  const onChangeValidar = (e) => {
    e.preventDefault();

    let sigue = true;
    if (props.op === 1) {

      if (txtPorFechas.current.checked === true && txtPorCliente.current.checked === false) {
        if (txtDesde.current.value === '' || txtHasta.current.value === '') {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione las Fechas a Consultar !', icono: 'informacion' });
          if (txtDesde.current.value === '' && txtHasta.current.value !== '') {
            txtDesde.current.focus()
          } else if (txtHasta.current.value === '' && txtDesde.current.value !== '') {
            txtHasta.current.focus()
          }
          sigue = false
        } else {
          imprimirGeneral();
        }

      } else if (txtPorFechas.current.checked === false && txtPorCliente.current.checked === true) {
        if (txtRifrespon.current.value === '') {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el RIF del Cliente a Consultar !', icono: 'informacion' });
          txtRifrespon.current.focus()
          sigue = false
        } else {
          imprimirGeneral();
        }
      } else if (txtPorFechas.current.checked === true && txtPorCliente.current.checked === true) {
        if (txtDesde.current.value === '' && txtHasta.current.value === '') {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Las Fechas a Consultar no Deben ir Vacias !', icono: 'informacion' });
          txtPorFechas.current.focus()
          sigue = false
        } else if (txtRifrespon.current.value === '') {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el RIF del Cliente a Consultar !', icono: 'informacion' });
          txtRifrespon.current.focus()
          sigue = false
        } else {
          imprimirGeneral();
        }
      } else {
        imprimirGeneral();
      }

    }

  }

  const onChekval = (e) => {

    if (e.target.id === 'tipoalmacen') {

      if (txtTodasFechas.current.checked === true) {

        setInputalmacen(0);
        setParafecha('');
        setDesde('');
        setHasta('');
        txtDesde.current.value = '';
        txtHasta.current.value = '';

      } else if (txtPorFechas.current.checked === true) {

        setInputalmacen(1);
        setParafecha('and n.fecha between ');

      }

    } else if (e.target.id === 'tipodisponible') {

      if (e.target.value === '1') {
        setDisponiblec('');
        setTituid('ReporteEstadoCeuntasyPorcobrarDos');
        setTituloc('LISTADO DE ESTADOS DE CUENTA');
      } else if (e.target.value === '2') {
        setDisponiblec('and n.status = 1');
        setTituid('ReporteEstadoCeuntasyPorcobrarDos');
        setTituloc('LISTADO DE ESTADOS DE CUENTA (PAGADAS)');
      } else if (e.target.value === '3') {
        setDisponiblec('and n.status = 0');
        setTituid('ReporteEstadoCeuntasyPorcobrar');
        setTituloc('LISTADO DE CUENTAS POR COBRAR');
      }

    } else if (e.target.id === 'tipoproducto') {

      if (txtTodosCliente.current.checked === true) {
        setInputproducto(0);
        setParacliente('');
        setIdclient('');
        txtNomrespon.current.value = '';
      } else if (txtPorCliente.current.checked === true) {
        setInputproducto(1);
        setParacliente('and n.idcliente = ');
      } else if (txtVipCliente.current.checked === true) {
        setInputproducto(2);
        setParacliente(' and ag.grupcli = ' + "''1''");
      } else if (txtRegulares.current.checked === true) {
        setInputproducto(3);
        setParacliente(' and ag.grupcli = ' + "''2''");
      }

    }

  }

  const imprimirGeneral = () => {

    let parameters;

    if (inputalmacen === 1) {
      parameters = "'" + '||quote_literal(' + desde + ')||' + "'" + ' and ' + "'" + '||quote_literal(' + hasta + ')';
    } else {
      parameters = "'";
    }

    var reporte = tituid;

    let condi = disponiblec + paracliente + idclient + parafecha + parameters;

    window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&condicion=" + "'" + condi + "&titulo=" + tituloc, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
  }

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });

  };

  const cerrarModal = () => {
    if (props.llamado === 2) {
      props.onHideRenderizar();
      props.onHideCancela();
    }
    blanquear();
    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
  }

  const handleAceptaCliente = (values) => {
    setMostrar1(false);

    txtCbmrif.current.value = values.rif.substring(0, 1);
    txtRifrespon.current.value = values.rif.substring(1, 11);
    txtNomrespon.current.value = values.nombre;
    selectResponsable(values.rif);
    setIdclient(values.idagente);
  };

  const catalogoProductoc = (e) => {
    e.preventDefault();
    setMostrar1(true);
  };

  const selectResponsable = (id) => {

    let campos = '*';
    let nomtab = 'agente';
    let nomid = 'rif';
    let nomid2 = 'cliente';
    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idagente > 0) {
            txtNomrespon.current.value = response.data.nombre;
            setIdclient(response.data.idagente);
            btnAcepta.current.focus();
          } else {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ RIF y/o Cliente no Registrado !', icono: 'informacion' });
            txtRifrespon.current.value = '';
            txtNomrespon.current.value = '';
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const onChange = (e) => {

    if (e.target.name === 'nci') {
      setTipofic(e.target.value);
    } else if (e.target.name === 'desde') {
      if (e.target.value > moment(fechasistema).format('YYYY-MM-DD')) {
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ La Fecha seleccionada no puede ser Mayor a la Fecha Actual !', icono: 'informacion' });
        txtDesde.current.value = moment(fechasistema).format('YYYY-MM-DD');
        txtDesde.current.focus()
      } else {
        setDesde("'" + moment(e.target.value).format('DD-MM-YYYY') + "'");
      }
    } else if (e.target.name === 'hasta') {
      setHasta("'" + moment(e.target.value).format('DD-MM-YYYY') + "'");
    }

  }

  const handleCliente = (e) => {
    e.preventDefault();
    if (e.which === 13 || typeof (e.which) === 'undefined') {
      if (e.target.value !== '') {
        selectResponsable(tiporif + e.target.value);
      }
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {

        if (props.op === 1) {

          if (props.report === "reporteestadodecuenta") {
            setTituloc('LISTADO DE ESTADOS DE CUENTA');
            setDisponiblec('');
          } else if (props.report === "reportecuentasporcobrar") {
            setTituloc('LISTADO DE CUENTAS POR COBRAR');
            setDisponiblec('and n.status = 0');
          }

          setTituid('ReporteEstadoCeuntasyPorcobrarDos');

          if (props.report !== "reportecuentasporcobrar") {
            txtTodosDispo.current.checked = true;
            txtCanceladas.current.checked = false;
            txtDeudas.current.checked = false;
          }

          txtTodasFechas.current.checked = true;
          txtTodosCliente.current.checked = true;
          txtVipCliente.current.checked = false;
          txtRegulares.current.checked = false;
          setParacliente('');
          setParafecha('');
          setDesde('');
          setHasta('');
          setTipofic('V');
          txtPorFechas.current.checked = false;
          txtPorCliente.current.checked = false;
          setHabilitado(false);
        } else {

          if (props.report !== "reportecuentasporcobrar") {
            txtTodosDispo.current.checked = false;
            txtCanceladas.current.checked = false;
            txtDeudas.current.checked = false;
          }

          txtTodasFechas.current.checked = false;
          txtTodosCliente.current.checked = false;
          txtVipCliente.current.checked = false;
          txtRegulares.current.checked = false;

          txtPorCliente.current.checked = false;
          txtPorFechas.current.checked = false;

          setHabilitado(true);
        }

      }}
    >
      <Modal.Header className='azulGradiant2 header-modal'>
        <div className='fw-bold' style={{ color: "#fff" }}><h3>{props.report === "reporteestadodecuenta" ? 'Imprimir Estados de Cuenta' : 'Imprimir Cuentas por Cobrar'}</h3></div>

        <a href='#' ref={btnSalir} disabled={botones.salir} onClick={cancelar} className='text-light' ><i className="fas fa-times fa-1x shadow" > {/* Salir */}</i></a>

      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === 'Exito.' ?
              cerrarModal() :
              setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
          }
          } />
        <MensajeSiNo mensaje={mensajesino}
          onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className='col-md-12 row mx-auto px-0'>

          <div className="row col-md-12 rounded mx-auto">

            <fieldset className='row col-sm-12 mx-auto border-azul rounded mb-1'>
              <legend className="float-none m-0 w-auto fs-4 fw-bold">Fecha:</legend>

              <div className='col-2 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" name="tipoalmacen" value="1" ref={txtTodasFechas} onChange={onChekval} id="tipoalmacen" type="radio" />
                  <label className="form-check-label" for="exampleRadi1">
                    Todos
                  </label>
                </div>
              </div>

              <div className='col-2 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" name="tipoalmacen" value="2" ref={txtPorFechas} onChange={onChekval} id="tipoalmacen" type="radio" />
                  <label className="form-check-label" for="exampleRadi2">
                    Por Fecha
                  </label>
                </div>
              </div>

              {inputalmacen === 1 ? <div className='col-7 row m-0'>

                <div className='col-6'>
                  <div className="input-group input-group-sm">
                    <label className="input-group-text" id="inputGroup-sizing-sm">Desde:</label>
                    <input type="date" ref={txtDesde} disabled={inputalmacen === 0 ? true : false} name='desde' onChange={onChange} className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  </div>
                </div>

                <div className='col-6'>
                  <div className="input-group input-group-sm">
                    <label className="input-group-text" id="inputGroup-sizing-sm">Hasta:</label>
                    <input type="date" ref={txtHasta} disabled={inputalmacen === 0 ? true : false} name='hasta' onChange={onChange} className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  </div>
                </div>

              </div> : ''}

            </fieldset>

            {props.report !== "reportecuentasporcobrar" ? <fieldset className='row col-sm-12 mx-auto border-azul rounded mb-1'>
              <legend className="float-none m-0 w-auto fs-4 fw-bold">Estatus del Pago:</legend>

              <div className='col-1 ml-auto'>
                <div className="form-check">
                  <input className="form-check-input" name="tipodisponible" value="1" ref={txtTodosDispo} onChange={onChekval} id="tipodisponible" type="radio" />
                  <label className="form-check-label" for="exampleRai1">
                    Todos
                  </label>
                </div>
              </div>

              <div className='col-1 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" name="tipodisponible" value="2" ref={txtCanceladas} onChange={onChekval} id="tipodisponible" type="radio" />
                  <label className="form-check-label" for="exampleRai2">
                    Canceladas
                  </label>
                </div>
              </div>

              <div className='col-4'>
                <div className="form-check">
                  <input className="form-check-input" name="tipodisponible" value="3" ref={txtDeudas} onChange={onChekval} id="tipodisponible" type="radio" />
                  <label className="form-check-label" for="exampleRai3">
                    Con Deudas
                  </label>
                </div>
              </div>

            </fieldset> : ''}

            <fieldset className='row col-sm-12 mx-auto border-azul rounded mb-1'>
              <legend className="float-none m-0 w-auto fs-4 fw-bold">Cliente:</legend>

              <div className='col-2 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" name="tipoproducto" value="1" ref={txtTodosCliente} onChange={onChekval} id="tipoproducto" type="radio" />
                  <label className="form-check-label" for="exampleRa1">
                    Todos
                  </label>
                </div>
              </div>

              <div className='col-2 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" name="tipoproducto" value="4" ref={txtRegulares} onChange={onChekval} id="tipoproducto" type="radio" />
                  <label className="form-check-label" for="exampleRa4">
                    Regulares
                  </label>
                </div>
              </div>

              <div className='col-2 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" name="tipoproducto" value="3" ref={txtVipCliente} onChange={onChekval} id="tipoproducto" type="radio" />
                  <label className="form-check-label" for="exampleRa3">
                    Clientes VIP
                  </label>
                </div>
              </div>

              <div className='col-2 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" name="tipoproducto" value="2" ref={txtPorCliente} onChange={onChekval} id="tipoproducto" type="radio" />
                  <label className="form-check-label" for="exampleRa2">
                    Por Cliente
                  </label>
                </div>
              </div>

              <input type='hidden' ref={txtIdProducto} />

              {inputproducto === 1 ? <div className='col-12 row m-0 py-3'>

                <div className="input-group input-group-sm col-4 ml-auto mb-1 px-1">
                  <label className="input-group-text" id="inputGroup-sizing-sm">RIF:</label>
                  <select className="form-select col-3" ref={txtCbmrif} name='nci' onChange={onChange} aria-label="Default select example">
                    <option value="V">V</option>
                    <option value="E">E</option>
                    <option value="J">J</option>
                    <option value="P">P</option>
                    <option value="G">G</option>
                  </select>
                  <input type="text" ref={txtRifrespon} disabled={inputproducto === 1 ? false : true} onKeyUp={handleCliente} onBlur={handleCliente} className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  <button disabled={inputproducto === 1 ? false : true} type="button" onClick={catalogoProductoc} className="btn btn-success"><i className="fas fa-search"></i></button>
                </div>

                <div className='col-12 px-1'>
                  <div className="input-group input-group-sm">
                    <label className="input-group-text" id="inputGroup-sizing-sm">Nombre del Cliente:</label>
                    <input type="text" ref={txtNomrespon} disabled={true} className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  </div>
                </div>

              </div> : ''}

            </fieldset>

          </div>

        </div>
      </Modal.Body >
      <Modal.Footer>
        <div className="row m-0 col-md-12 mx-auto">

          <div className='col-md-4 ml-auto px-0 m-0 d-flex justify-content-end'>
            <button ref={btnAcepta} disabled={habilitado} onClick={onChangeValidar} className="btn btn-sm rounded-pill btn-primary mx-1"><i className="fas fa-print">  Imprimir</i></button>
            <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill mx-1"><i className="fas fa-window-close"> Cancelar</i></button>
          </div>
        </div>

      </Modal.Footer>

      <CatalogoCliente
        show={mostrar1}
        nomid='cliente'
        onHideCancelar={() => setMostrar1(false)}
        onHideAceptaCatalogo={handleAceptaCliente}
      />
    </Modal >
  );
}




// WEBPACK FOOTER //
// ./src/components/finanzas/modalImprimirCtasxCobrarEstadoCuenta.js